import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "role-card-container"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "margin-top": "1.0rem"
  }
};
const _hoisted_3 = {
  class: "operationBar"
};
import { provide, ref, computed, watch, onMounted } from 'vue';
import store from '@/store';
import { ElButton, ElRow, ElSegmented, ElCol, ElMessage } from 'element-plus';
import { request } from '@/manager/net_manager';
import RoleCardAttribute from '@/components/Role/RoleCardAttribute.vue';
import RoleCardCapabilitiesSkills from '@/components/Role/RoleCardCapabilitiesSkills.vue';
import RolePocket from '@/components/Role/RolePocket.vue';
import RoleCardAchievementTalent from '@/components/Role/RoleCardAchievementTalent.vue';
import RoleCardResumes from '@/components/Role/RoleCardResumes.vue';
import 'element-plus/es/components/segmented/style/css';
import { inApostleType } from "@/tools/utils"; // pre-declaration

export default {
  __name: 'RoleCard',
  props: {
    roleId: {
      type: [String, Number, null],
      required: true
    }
  },
  emits: ['closeRole'],

  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const roleMode = ref(null);
    const roleBaseContainer = ref(null); // computed

    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const attribute = computed(() => {
      return store.state.role_info[props.roleId]?.attribute ?? null;
    });
    const modeOptions = computed(() => {
      let buffer = [{
        label: '属性与状态',
        value: 'attribute'
      }, {
        label: '能力与技能',
        value: 'capabilities&skills'
      }, {
        label: '资产列表',
        value: 'pocket'
      }, {
        label: '功勋与天赋',
        value: 'achievement&talent'
      }, {
        label: '模组经历',
        value: 'resumes'
      }]; // if (attribute.value && attribute.value.reborn > 0) {
      //   buffer.push({
      //     label: '重新构建',
      //     value: 'reborn'
      //   })
      // }

      return buffer;
    }); // functions

    const getData = () => {
      request('role/get/', {
        'role_id': props.roleId
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          store.commit('update_role_info', {
            role_id: props.roleId,
            key: 'attribute',
            value: response.data
          });

          if (!roleMode.value && modeOptions.value) {
            roleMode.value = modeOptions.value[0]['value'];
          }

          const capabilities = response.data['capabilities'];
          const assigned_capability_point = capabilities.reduce((sum, item) => {
            return sum + item?.value ?? 0;
          }, 0);
          const assignable_capability_point = response.data['capability_point'] - assigned_capability_point;
          const skills = response.data['skills'];
          const assigned_skill_point = skills.reduce((sum, item) => {
            return sum + item?.increase_count ?? 0;
          }, 0);
          const assignable_skill_point = response.data['skill_point'] - assigned_skill_point;
          store.commit('update_role_info', {
            role_id: props.roleId,
            key: 'capability_point',
            value: assignable_capability_point
          });
          store.commit('update_role_info', {
            role_id: props.roleId,
            key: 'skill_point',
            value: assignable_skill_point
          });
        }
      }); // if (!roleMode.value && modeOptions.value) {
      //   roleMode.value = modeOptions.value[0]['value']
      // }
    };

    const updateRole = (key = null) => {
      if (roleMode.value === 'reborn') {
        roleMode.value = modeOptions.value[0].value ?? null;
      }

      store.commit('delete_role_info', {
        role_id: props.roleId,
        key: key
      });
      store.dispatch('get_roles');
      getData();
    };

    const closeRole = () => {
      emits('closeRole');
    };

    const updateMysteriousLevel = () => {
      request('role/mysterious_update/', {
        'role_id': props.roleId
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          ElMessage.success({
            message: '更新完成',
            duration: 1500
          });
          updateRole();
        }
      });
    };

    const scrollToTop = () => {
      if (roleBaseContainer.value) {
        roleBaseContainer.value.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }; // post-declaration


    __expose({
      getData
    });

    provide('roleService', {
      update: updateRole
    }); // lifecycle

    onMounted(() => {
      if (props.roleId && !attribute.value) {
        getData();
      }

      if (!roleMode.value && modeOptions.value.length !== 0) {
        roleMode.value = modeOptions.value[0].value;
      }
    }); // watcher

    watch(() => props.roleId, newVal => {
      if (newVal && !attribute.value) {
        getData();
      }

      let buffer = modeOptions.value.filter(item => item.value === roleMode.value);

      if (buffer.length === 0) {
        roleMode.value = modeOptions.value[0].value ?? null;
      }
    });
    return (_ctx, _cache) => {
      return __props.roleId ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_unref(inApostleType)(userType.value) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(ElCol), {
        offset: 1,
        span: 22
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), {
          style: {
            "justify-content": "flex-end"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElButton), {
            onClick: updateMysteriousLevel
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 更新神秘等级 ", -1)]))]),
            _: 1
          }), _createVNode(_unref(ElButton), {
            onClick: closeRole
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 关闭角色卡 ", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElSegmented), {
        modelValue: roleMode.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => roleMode.value = $event),
        options: modeOptions.value
      }, {
        default: _withCtx(({
          item
        }) => [_createElementVNode("div", null, _toDisplayString(item.label), 1)]),
        _: 1
      }, 8, ["modelValue", "options"])]), __props.roleId ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "role-segmented-container",
        ref_key: "roleBaseContainer",
        ref: roleBaseContainer
      }, [roleMode.value === 'attribute' ? (_openBlock(), _createBlock(RoleCardAttribute, {
        key: 0,
        "role-id": __props.roleId
      }, null, 8, ["role-id"])) : roleMode.value === 'capabilities&skills' ? (_openBlock(), _createBlock(RoleCardCapabilitiesSkills, {
        key: 1,
        "role-id": __props.roleId,
        onToTop: scrollToTop
      }, null, 8, ["role-id"])) : roleMode.value === 'pocket' ? (_openBlock(), _createBlock(RolePocket, {
        key: 2,
        "role-id": __props.roleId
      }, null, 8, ["role-id"])) : roleMode.value === 'achievement&talent' ? (_openBlock(), _createBlock(RoleCardAchievementTalent, {
        key: 3,
        "role-id": __props.roleId
      }, null, 8, ["role-id"])) : roleMode.value === 'resumes' ? (_openBlock(), _createBlock(RoleCardResumes, {
        key: 4,
        "role-id": __props.roleId
      }, null, 8, ["role-id"])) : _createCommentVNode("", true)], 512)) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }

};